import ControlButtons from "../ControlButtons";
import NavLinks from "../NavLinks";
import MobileSearchButton from "../MobileSearchButton";
import SearchForm from "../forms/SearchForm";
import UserMenuTrigger from "../UserMenuTrigger";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { Link } from "react-router";
import { cn } from "@/lib/utils";
import PopoverWrapper from "../PopoverWrapper";
import { Plus } from "lucide-react";

export default function NavBar() {
  const isMobile = useMediaQuery("mobile");

  return isMobile ? (
    <div
      className={cn(
        "fixed bottom-0 left-0 w-full",
        "pt-4 pb-2 px-2 z-10 border-t bg-popover",
        "flex justify-around gap-y-4 gap-x-4",
      )}
      style={{ boxShadow: "0 -1px 2px 0px rgb(0 0 0 / 0.05)" }}
    >
      {/* <div className={cn("w-full")}> */}
      {/* <NavLinks /> */}
      {/* </div> */}


      <div className={cn("w-full")}>
      <NavLinks />
      </div>

      <div className={cn("flex items-center")}>
        <PopoverWrapper
          trigger={<Plus className={cn("w-5 h-5")} />}
          content={
            <div className={cn("flex flex-col")}>
              <ControlButtons />
            </div>
          }
        />
      </div>

      <div className={cn("flex gap-x-4")}>
        <MobileSearchButton />

        <UserMenuTrigger />
      </div>
    </div>
  ) : (
    <div className="z-10 col-span-1 flex flex-col w-full gap-4 px-2 py-3 relative row-start-1 justify-start">
      <ControlButtons />
      <hr className="my-2 hidden md:inline" />
      <div className="hidden md:inline">
        <SearchForm />
      </div>
      <div className="md:hidden">
        <MobileSearchButton />
      </div>
      <hr className="my-2 hidden md:inline" />
      <NavLinks />
      <hr className="my-2" />
      <div className="h-full flex flex-col justify-start ml-2">
        <span className="text-xs flex items-center gap-x-2">
          &gt;{" "}
          <Link className="text-xs hover:text-flamingo" to="/settings">
            Settings
          </Link>
        </span>
        <span className="text-xs flex items-center gap-x-2">
          &gt;{" "}
          <Link className="text-xs hover:text-flamingo" to="/help">
            Help
          </Link>
        </span>
      </div>
    </div>
  );
}
